import { useMask } from '@react-input/mask';
import { Input, InputProps } from 'antd';
import { forwardRef } from 'react';

export const DobInput = forwardRef(
  (props: Omit<InputProps, 'inputMode'>, ref) => {
    const inputRef = useMask({
      mask: '__/__/____',
      replacement: { _: /\d/ },
      showMask: true,
    });

    return (
      <Input
        placeholder="MM/DD/YYYY"
        {...props}
        inputMode="numeric"
        ref={(el) => {
          if (el) {
            if (typeof ref === 'function') {
              ref(el);
            } else if (ref) {
              ref.current = el;
            }
            inputRef.current = el?.nativeElement as any;
          }
        }}
      />
    );
  }
);
